<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="mb-0 font-medium text-uppercase">
            <router-link to="/apps/templates-categories" class="text-center navbar-brand">
              <strong>
                <i class="fas fa-chevron-left"></i> Back
              </strong>
            </router-link>
            <span>Edit Template</span>
          </h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/apps/templates-categories">Templates</router-link>
              </li>
              <li v-if="id" class="breadcrumb-item active" aria-current="page">{{ id }}</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <div class="card">
        <div class="card-body">
          <form class="needs-validation form-create-category" @submit.prevent="submitFormDetailCategory">
            <div class="d-block form-group" :class="{error: errPropertyMapping['slug']}">
              <label for="slug">Slug</label>
              <div>
                <input v-model="dataCategory.slug" class="form-control" type="text" name="slug" required />
              </div>
              <span class="msg-error">{{ msgError }}</span>
            </div>
            <div class="d-block form-group" :class="{error: errPropertyMapping['shortName']}">
              <label for="shortName">Short name</label>
              <div>
                <input v-model="dataCategory.shortName" class="form-control" type="text" name="shortName" required />
              </div>
              <span class="msg-error">{{ msgError }}</span>
            </div>
            <div class="d-block form-group" :class="{error: errPropertyMapping['name']}">
              <label for="name">Name</label>
              <div>
                <input v-model="dataCategory.name" class="form-control" type="text" name="name" required />
              </div>
              <span class="msg-error">{{ msgError }}</span>
            </div>
            <div class="d-block form-group">
              <label for="text">Description</label>
              <div>
                <textarea v-model="dataCategory.description" rows="6" class="category-content"></textarea>
              </div>
            </div>
            <div>
              <span>
                <input id="active" v-model="dataCategory.active" name="active" type="checkbox">
                <label for="active"> &nbsp; Show on Public Template Library</label>
              </span>
            </div>
            <div>
              <span>
                <input id="onlyPresenter" v-model="dataCategory.onlyPresenter" name="onlyPresenter" type="checkbox">
                <label for="onlyPresenter"> &nbsp; Show for Presenter</label>
              </span>
              <div class="d-block form-group">
                <label for="text">SEO content (accept HTML)</label>
                <div>
                  <textarea v-model="dataCategory.seo" rows="6" class="category-content"></textarea>
                </div>
              </div>
              <div class="d-block form-group">
                <label for="order">Order</label>
                <div>
                  <input v-model="dataCategory.order" class="form-control" type="number" name="name" />
                </div>
              </div>
              <div class="d-block form-group" :class="{error: errPropertyMapping['featuredPresentationId']}">
                  <label for="template-feature-id">Featured Template ID <br>
                    <span class="msg-note">Note: The featured template should belong to this category and must not have been featured in any other category.</span>

                  </label>
                <div>
                  <input v-model="dataCategory.featuredPresentationId" class="form-control" type="number" name="template-feature-id" />
                </div>
                <span class="msg-error">{{ msgError }}</span>
                <span
                  v-if="!dataCategory.featuredPresentationId && !errPropertyMapping['featuredPresentationId']"
                  class="msg-warning"
                >
                  Warning: Featured Template ID is not input.
                </span>
              </div>
            </div>
            <div class="text-center">
              <button v-if="!idOpenDetailCategory" type="submit" class="mr-2 btn btn-primary">
                Create
                <i v-if="isCreatingCategory" class="fa fa-spinner fa-spin"></i>
              </button>
              <button v-if="idOpenDetailCategory" type="submit" class="mr-2 btn btn-primary">
                Update
                <i v-if="isCreatingCategory" class="fa fa-spinner fa-spin"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config"

export default {
  name: "Detail",
  components: {},
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      errPropertyMapping: {},
      msgError: '',
      dataCategory: {},
      idOpenDetailCategory: null,
      isCreatingCategory: false,
    }
  },
  created() {
    this.initOptions = {
      menubar: false,
      toolbar: false,
      height: "200"
    }
  },
  mounted() {
    this.idOpenDetailCategory = this.id
    if (this.idOpenDetailCategory) {
      this.getCategoryDetail(this.idOpenDetailCategory)
    }
  },
  methods: {
    async getCategoryDetail(id) {
      const res = await this.callApiGetDetail(id)
      if (!res) {
        this.$toasted.error('Error get category detail!')
        return false
      }
      this.dataCategory = res.body
    },
    resetDataNewCreateCategory() {
      this.dataCategory = {
        name: '',
        shortName: '',
        seo: '',
        slug: '',
        description: '',
        onlyPresenter: false,
        active: false,
        order: null,
        featuredPresentationId: null,
      }
    },
    resetErrorMsg() {
      this.errPropertyMapping = {
        shortName: false,
        name: false,
        slug: false,
        featuredPresentationId: false,
      }
      this.msgError = ''
    },
    submitFormDetailCategory() {
      if (this.idOpenDetailCategory) {
        this.updateCategory()
        return
      }
      this.createCategory()
    },
    async updateCategory() {
      if (!await this.updateOrCreate()) {
        this.$toasted.error('Update category error!', { duration: 1000 })
        return false
      }
      this.$toasted.success('Update category success!', { duration: 500 })
      return true
    },
    async createCategory() {
      if (!await this.updateOrCreate()) {
        this.$toasted.error('Create category error!', { duration: 1000 })
        return false
      }
      this.$router.push({ name: "TemplateCategories" })
      this.$toasted.success('Update category success!', { duration: 500 })
      return true
    },
    _buildApiPayload(input) {
      const payload = { ...input };
      payload.featuredPresentationId =
        payload.featuredPresentationId === '' ||
        payload.featuredPresentationId === null ||
        payload.featuredPresentationId === undefined ||
        isNaN(Number(payload.featuredPresentationId)) ||
        Number(payload.featuredPresentationId) === 0
          ? null
          : Number(payload.featuredPresentationId);

      return payload
    },
    async updateOrCreate() {
      this.resetErrorMsg()
      if (this.isCreatingCategory) {
        return false
      }
      this.isCreatingCategory = true
      const payload = this._buildApiPayload(this.dataCategory)
      const res = await this.callApiUpdateOrCreate(payload)
      this.isCreatingCategory = false
      if (!res || res.status !== 200) {
        return false
      }
      if (res.body.status === 0) {
        this.errPropertyMapping[res.body.property] = true
        this.msgError = res.body.msg
        return false
      }
      return true
    },
    async callApiGetDetail(categoryId) {
      try {
        return await this.$http
          .get(`${Config.api.getPresentationCategoryDetail}/${categoryId}`)
      } catch (e) {
        console.log(e)
        return false
      }
    },
    async callApiCreateCategory(payload) {
      try {
        return await this.$http
          .post(Config.api.createPresentationCategories, payload)
      } catch (e) {
        console.log(e)
        return false
      }
    },
    callApiUpdateOrCreate(payload) {
      if (this.idOpenDetailCategory) {
        return this.callApiUpdateCategory(this.idOpenDetailCategory, payload)
      }
      return this.callApiCreateCategory(payload)
    },
    async callApiUpdateCategory(id, payload) {
      try {
        return await this.$http
          .patch(`${Config.api.updatePresentationCategories}/${id}`, payload)
      } catch (e) {
        console.log(e)
        return false
      }
    },
    hideAndResetModalCreateCategory() {
      this.resetDataNewCreateCategory()
      this.resetErrorMsg()
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.description {
  display: inline-block;
  max-height: 100px;
  max-width: 350px;
  overflow: auto;
}

.break-any {
  word-wrap: anywhere;
}

.small-text {
  font-size: 12px;
  color: #888;
}

.category-content {
  width: 100%;
  padding: 16px;
}

.msg-warning {
  color: orange;
  display: block;
  font-size: 0.75rem;
  padding-top: 5px;
}

.msg-note {
  color: #888;
  font-size: 12px;
}
</style>
